import type { LucideIcon } from 'lucide-react'
import {
  Activity,
  Bot,
  Briefcase,
  Building2,
  Database,
  Eye,
  Heart,
  Leaf,
  MessageSquare,
  Plane,
  Radio,
  Search,
  Sparkles,
  Stethoscope,
  Users,
} from 'lucide-react'

export const LANDING_ICON_REGISTRY = {
  Activity,
  Bot,
  Briefcase,
  Building2,
  Database,
  Eye,
  Heart,
  Leaf,
  MessageSquare,
  Plane,
  Radio,
  Search,
  Sparkles,
  Stethoscope,
  Users,
} satisfies Record<string, LucideIcon>

export type LandingIconKey = keyof typeof LANDING_ICON_REGISTRY

export function getLandingIcon(iconName?: string): LucideIcon {
  if (iconName && iconName in LANDING_ICON_REGISTRY) {
    return LANDING_ICON_REGISTRY[iconName as LandingIconKey]
  }
  return Sparkles
}
